import React from 'react';
import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';
import SnackBarCustom from 'src/frontend-common/components/SnackbarCustom';

interface ErrorData {
  message: string;
  violations: { _all: string };
}
export interface Props {
  isSuccess: boolean;
  isError: boolean;
  successMessage: string;
  error: FetchBaseQueryError | SerializedError | undefined;
  onSuccess?: () => void;
  onError?: () => void;
}

const SnackBarCompleteHandler: React.FC<Props> = ({ isSuccess, isError, successMessage, error, onSuccess, onError }) => {
  const [snackBarMessage, setSnackBarMessage] = React.useState<string>('');
  const [snackBarStatusSuccess, setSnackBarStatusSuccess] = React.useState<boolean>(true);
  const [showSnackBar, setShowSnackBar] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (isSuccess || isError) {
      if (isSuccess) {
        setSnackBarMessage(successMessage);
        setSnackBarStatusSuccess(true);
        if (onSuccess) {
          onSuccess();
        }
      }
      if (isError) {
        setSnackBarStatusSuccess(false);
        let message = 'An error occurred, please try again.';
        if (error && 'data' in error && typeof error.data !== 'string') {
          const errorData = error.data as ErrorData;
          message = errorData.message !== '' ? errorData.message : message;
          if (typeof errorData.violations === 'string') {
            message = `Error: ${errorData.violations}`;
          } else if (errorData.violations && typeof errorData.violations !== 'string') {
            const fieldName = Object.keys(errorData.violations)[0]?.split('_')[0];
            if (Object.values(errorData.violations)[0]?.trim()) {
              message = `${
                fieldName && fieldName !== '0' ? `Error: ${Object.keys(errorData.violations)[0]?.split('_')[0]},` : 'Error:'
              } ${Object.values(errorData.violations)[0]?.toLocaleLowerCase()}`;
            }
          }
        }
        setSnackBarMessage(message);
        if (onError) {
          onError();
        }
      }
      setShowSnackBar(true);
    }
  }, [isSuccess, isError, error]);

  return (
    <SnackBarCustom
      open={showSnackBar}
      onClose={() => setShowSnackBar(false)}
      severity={snackBarStatusSuccess ? 'success' : 'error'}
      message={snackBarMessage}
      autoHideDuration={snackBarStatusSuccess ? 3000 : 10000}
    />
  );
};

export default SnackBarCompleteHandler;
